module.exports = __webpack_public_path__ + "img/car_sendai18.af613d39.jpg";